"use client";

import { MDXProvider as MDXProviderClient } from "next-mdx-remote-client";
import { components } from "../blog/mdx-components";

export default function MDXProvider({
	children,
}: { children: React.ReactNode }) {
	return (
		<MDXProviderClient components={components}>{children}</MDXProviderClient>
	);
}
